export default __webpack_public_path__ + "assets/images/63eb300bb8854d678e2252f114e8b8b2.svg";